import React from "react"

import { useApp } from "../../../hooks/useApp"
import { useSearch } from "../../../hooks/useSearch"
import { useWindowSize } from "../../../hooks/useWindowSize"

export const withSearchForm = Component => ({ name = "SearchForm", className, location, componentId }) => {
  const { globalStateReducer } = useApp()
  const { getSearchFormConfig, getSuggestionConfig, getQueryString, processSearch } = useSearch(location)
  const config = getSearchFormConfig()
  const suggestionsConfig = getSuggestionConfig()
  const [{ activeSearch }] = globalStateReducer
  Component.displayName = name
  const {
    windowSize: { isMobile },
  } = useWindowSize()
  return (
    <Component
      activeSearch={isMobile ? true : activeSearch}
      className={className}
      config={config}
      suggestionsConfig={suggestionsConfig}
      componentId={componentId}
      processSearch={processSearch}
      query={getQueryString()}
    />
  )
}
